import { useEffect, useState } from 'react'
import { MainTemplate } from 'templates/MainTemplate'

import { CompanyInfo } from './components/CompanyInfo'
import { HeaderAccount } from './components/header-account'
import { UserInfoLayout } from './components/UserInfoLayout'

export default function MyAccount() {
  const [activeMenuItem, setActiveMenuItem] = useState<number>(0)
  const handleClick = (index: number) => {
    setActiveMenuItem(index)

    const url = new URL(window.location.href)
    url.searchParams.set('index', index.toString())
    window.history.pushState({}, '', url)
  }

  useEffect(() => {
    const url = new URL(window.location.href)
    const index = url.searchParams.get('index')
    if (index) {
      setActiveMenuItem(parseInt(index))
    }
  }, [])

  return (
    <MainTemplate>
      <section className="flex flex-col px-2 md:container md:min-h-[calc(100svh-15rem)] h-full">
        <HeaderAccount
          handleClick={handleClick}
          activeMenuItem={activeMenuItem}
        />
        {activeMenuItem === 0 && <CompanyInfo />}
        {activeMenuItem === 1 && <UserInfoLayout />}
      </section>
    </MainTemplate>
  )
}
